import React from 'react'
import styles from './styles.module.css'
import check from "../../../assets/for_this/Check.svg"
import info from "../../../assets/for_this/info.svg"
import { Button } from '@chakra-ui/react'

const ActivePlan = () => {
    return (
        <div className={styles.container}>
            
            <p>Expires on 12 Aug 2023</p>
            <div className={styles.container1} >
                <div className={styles.topBtn}>
                    Current active plan
                </div>
                <h5 style={{marginTop:"10px"}}>
                    Starter
                </h5>
                <div className={styles.spanDiv}>
                    <span className={styles.Span}>
                        <span className={styles.innerSpan}>
                            <img src={check} alt="" />
                            Guaranteed place on our map
                        </span>
                        <img src={info} alt="" />
                    </span>
                    <span className={styles.Span}>
                        <span className={styles.innerSpan}>
                            <img src={check} alt="" />
                            Preferred representation
                        </span>
                        <img src={info} alt="" />
                    </span>
                    <span className={styles.Span}>
                        <span className={styles.innerSpan}>
                            <img src={check} alt="" />
                            Expand your visibility
                        </span >
                        <img src={info} alt="" />
                    </span>
                    <span className={styles.Span}>
                        <span className={styles.innerSpan}>
                            <img src={check} alt="" />
                            Stamp card advantage
                        </span>
                        <img src={info} alt="" />
                    </span>
                    <span className={styles.Span}>
                        <span className={styles.innerSpan}>
                            <img src={check} alt="" />
                            In app advertising
                        </span>
                        <img src={info} alt="" />
                    </span>
                    <span className={styles.Span}>
                        <span className={styles.innerSpan}>
                            <img src={check} alt="" />
                            Personalize your profile
                        </span>
                        <img src={info} alt="" />
                    </span>
                    <span className={styles.Span}>
                        <span className={styles.innerSpan}>
                            <img src={check} alt="" />
                            Send push notification
                        </span>
                        <img src={info} alt="" />
                    </span>

                    <Button className={styles.submit}>Cancel current subscription</Button>
                </div>
            </div>


            <t>Upgrade to</t>

            <div className={styles.container2}>
                <div className={styles.container3}>
                    <h5>
                        Business
                    </h5>
                    <div className={styles.spanDiv}>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Guaranteed place on our map
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Preferred representation
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Expand your visibility
                            </span >
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Stamp card advantage
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                In app advertising
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Personalize your profile
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Send push notification
                            </span>
                            <img src={info} alt="" />
                        </span>

                        <Button className={styles.submit}>Upgrade from 19,99€</Button>


                    </div>

                </div>
                <div className={styles.container3}>
                    <h5>
                        Enterprise
                    </h5>
                    <div className={styles.spanDiv}>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Guaranteed place on our map
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Preferred representation
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Expand your visibility
                            </span >
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Stamp card advantage
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                In app advertising
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Personalize your profile
                            </span>
                            <img src={info} alt="" />
                        </span>
                        <span className={styles.dSpan}>
                            <span className={styles.innerSpan}>
                                <img src={check} alt="" />
                                Send push notification
                            </span>
                            <img src={info} alt="" />
                        </span>

                        <Button className={styles.submit}>Upgrade from 19,99€</Button>


                    </div>

                </div>

            </div>
        </div>
    )
}

export default ActivePlan